export const demoCall = {
  /** 着信の前に出す「体験する」案内と確認ダイアログ */
  offer: {
    cta: "無料通話を体験する",
    /** 「今すぐビデオ通話できる女の子」の行に出す丸アイコンの下のラベル */
    iconLabel: "AIと無料通話",
    /** coco+ のダーク配色の丸アイコンの下のラベル（デザイン 1-4） */
    iconLabelDark: "無料通話を体験",
    /** 丸アイコンのバッジ */
    iconBadge: "無料",
    confirmTitle: "電話かけても大丈夫ですか？",
    confirmBody: "着信時はコール音が鳴ります。\n音量に気をつけてください。",
    yes: "はい",
    no: "やめておく",
  },
  incomingBanner: {
    title: "無料通話のお誘い",
    appeal: "🎁 無料でAIの女の子とビデオ通話を体験してみませんか？",
    onceBadge: "🔥 初回1回限り",
    label: "📞 AIから着信が来ています",
    freeBadge: "無料",
    nameWithAi: (args: { name: string }) => `${args.name}（AIちゃん）`,
    accept: "応答",
    decline: "拒否",
  },
  inCall: {
    header: "無料通話中",
    end: "終了",
    connecting: "接続中…",
    /** 非活性の遠隔バイブを押したときのトースト */
    lovenseHint: "遠隔バイブ機能は\nライブ画面にて説明します",
    /** 通話中に減って見えるポイントが架空であることの断り書き */
    demoPointTitle: "体験用のポイント表示です",
    demoPointNote: "実際のポイントは減りません",
  },
} as const;
